import { strategiesEndpoints, type Strategy, type StrategyQueryParams, StrategyQueryParamsSchema } from "../../../api";
import { useStrapiList, type UseStrapiListOptions } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

type UseStrategiesProps = UseStrapiListOptions;

const useStrategies = (props?: UseStrategiesProps) => {
  const { items: strategies, ...other } = useStrapiList<Strategy>({
    ...props,
    load: (params) => {
      const parsed = StrategyQueryParamsSchema.parse(params);
      return loadStrategies(parsed);
    },
    onLoadError: (err: unknown) => {
      handleError(getErrorMessage(err, "Strategies loading failed"));
    },
  });

  return {
    strategies,
    ...other,
  };
};

export const loadStrategies = async (params?: StrategyQueryParams) => {
  try {
    // Omit populate from validated params since getStrategies has a generic populate constraint
    // that expects readonly StrategyPopulateField[], not string[]
    const { populate: _populate, ...rest } = params || {};
    return await strategiesEndpoints.getStrategies(rest);
  } catch (err: unknown) {
    handleError(getErrorMessage(err, "Strategies loading failed"));
  }
};

export default useStrategies;
